import React from 'react';

export const KitchenSvg: React.FunctionComponent = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99996 6.66667H6.66663V2H5.33329V6.66667H3.99996V2H2.66663V7.33333C2.66663 8.436 3.56396 9.33333 4.66663 9.33333H5.33329V14H6.66663V9.33333H7.33329C8.43596 9.33333 9.33329 8.436 9.33329 7.33333V2H7.99996V6.66667ZM12.6666 2H12C11.2273 2 10.6666 2.84133 10.6666 4V9.33333H12V14H13.3333V2.66667C13.3333 2.298 13.0353 2 12.6666 2Z"
      fill="#333333"
    />
  </svg>
);
